/* eslint-disable @typescript-eslint/no-explicit-any */
export const DEFAULT_PAGE_SIZE = 30;

export const States: string[] = [];

export function extract<T>(
  properties: Record<keyof T, true>,
  convertor?: (source: any) => any,
) {
  return function (value: T) {
    const result = {} as T;
    for (const property of Object.keys(properties) as (keyof T)[]) {
      result[property] = convertor
        ? convertor(value[property])
        : value[property];
    }
    return result;
  };
}
